<style>
@import '../../custom/css/cotacao.css';
.btn-function {
  cursor: pointer;
  color: rgb(255, 255, 255);
  font-size: 0.75em;
  font-family: 'Roboto', sans-serif;
  text-align: center;
  text-transform: uppercase;
  border-radius: 5px;
  -webkit-box-shadow: 3px 3px 2px rgb(0 0 0 / 10%);
  box-shadow: 3px 3px 2px rgb(0 0 0 / 10%);
  display: inline-block;
  padding: 6px 8px 6px;
  margin: 2px 0px;
  width: 100% !important;
}
.btn-voltar {
  background: rgb(237, 103, 12);
}
.btn-rejeitar {
  background:rgb(233, 10, 10);
}
.btn-aprovar {
  background:#28a745;
}
.aprovarPedido {
  float: right;
  color: rgb(233, 10, 10);
}
</style>

<template>
  <div id="cotacao-aprovada" class="cotacao" v-if="!checkIsEmpty(cotacao)">
    <div class="row m-0">
      <div class="col-12">
        <h1 class="title font-weight-bold text-uppercase">Pedido Aprovado</h1>
        <hr class="linha-amarela" />
      </div>
      <div class="col-12">
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
                alt="Ícone para representar o Orçamento"
              />
            </div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Data:
                <div class="cc-sub-result">
                  {{ this.cotacao[0].atualizado_em }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Cód:
                <div class="cc-sub-result">
                  {{ this.cotacao[0].cot_cotacao_id }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Preferência:
                <div class="cc-sub-result">
                  {{ this.cotacao[0].cot_preferencia }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Respondidos:
                <div class="cc-sub-result">
                  {{ quantProdutoRespondidos }} de {{ totalProdutos }}
                </div>
              </div>
            </div>
          </div>
          <div class="cc-content p-0" v-if="this.cotacao[0].produtos !== null">
            <div class="table-responsive">
              <h5 class="text-indent-5px">Inseridos pelo cliente</h5>
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Medida</th>
                    <th class="th">Undidade</th>
                    <th class="th">Subtotal</th>
                    <th class="th">Disponível</th>
                    <th class="th">Rejeitado</th>
                    <th class="th">Dúvidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in this.cotacao[0].produtos"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">
                        {{ produto.produto_nome }}
                      </div>
                      <div v-else>Não tem {{ produto.produto_nome }}</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.marca_nome !== null">
                        {{ produto.marca_nome }}
                      </div>
                      <div v-else>Sem marca</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <span class="ml-4">{{ produto.qtd_quantidade }}</span>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.tipo_medida_nome !== null">
                        {{ produto.tipo_medida_nome }}
                      </div>
                      <div v-else>Sem medida</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_unidades }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_total }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.rejeitar == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="cc-content p-0"
            v-if="this.cotacao[0].produtosImagemArquivo !== null"
          >
            <div class="table-responsive">
              <h5 class="text-indent-5px">Produtos do arquivo</h5>
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Medida</th>
                    <th class="th">Undidade</th>
                    <th class="th">Subtotal</th>
                    <th class="th">Disponível</th>
                    <th class="th">Rejeitado</th>
                    <th class="th">Dúvidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in this.cotacao[0]
                      .produtosImagemArquivo"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">
                        {{ produto.produto_nome }}
                      </div>
                      <div v-else>Não tem {{ produto.produto_nome }}</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.marca_nome !== null">
                        {{ produto.marca_nome }}
                      </div>
                      <div v-else>Sem marca</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <span class="ml-4">{{ produto.qtd_quantidade }}</span>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.medida_nome !== null">
                        {{ produto.medida_nome }}
                      </div>
                      <div v-else>Sem medida</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_unidades }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_total }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.rejeitar == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="cc-content">
            <!-- Campo de arquivo -->
            <div class="row m-0" v-if="cotacao[0].arquivo !== null">
              <div class="col-12 p-0 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_arquivo !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_arquivo }}
                </div>
                <div
                  class="d-inline-block m-l-20px"
                  v-if="cotacao[0].arquivo !== null"
                >
                  <a
                    :href="`${getImagesAddress}` + cotacao[0].arquivo"
                    class="btn btn-primary c-pointer fs-14 text-uppercase bg-dark-blue"
                    download
                  >
                    Baixar arquivo
                    <i class="fas fa-file-upload m-l-7px"></i>
                  </a>
                </div>
              </div>
            </div>
            <!-- Campo de imagem -->
            <div class="row m-0" v-if="cotacao[0].imagem !== null">
              <div class="col-12 p-0 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_foto !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_foto }}
                </div>
                <DownloadImages :allImages="this.cotacao[0].imagem" />
              </div>
            </div>
          </div>
          <div class="cc-content">
            <div class="row m-0">
              <div class="col-4 p-0" v-if="!checkIsEmpty(cotacao[0].cot_cep)">
                <b class="font-weight-bold text-uppercase fs-14"
                  >CEP de entrega:</b
                >
                {{ cotacao[0].cot_cep }}
              </div>
              <div class="col-4 p-0" v-else>
                <b class="font-weight-bold text-uppercase fs-14">Forma de entrega: </b>
                <span>Retirar na loja</span>
              </div>
              <div class="col-2" v-if="!checkIsEmpty(cotacao[0].cot_cep)">
                <b class="font-weight-bold text-uppercase fs-14">Frete:</b>
                {{ cotacao[0].cot_frete }}
              </div>
              <div class="col-4 p-0 text-right">
                <div class="prazo-entrega text-right">
                  <b class="font-weight-bold text-uppercase fs-14">Meio de pagamento:</b>
                  {{ cotacao[0].pagamento_realizado }}
                </div>
              </div>
              <div class="col-4 p-0 text-right">
                <div class="prazo-entrega text-right">
                  <b class="font-weight-bold text-uppercase fs-14">Valor Total:</b>
                  {{ cotacao[0].cot_valor_total }}
                </div>
              </div>
            </div>
          </div>
          <div class="cc-content">
            <div class="condicoes-pagamento-entrega">
              <b class="font-weight-bold text-uppercase fs-14"
                >Orçamento válido até:</b
              >
              {{ this.cotacao[0].cot_validade }}
              <span class="aprovarPedido"><b>Aprovar pedido até:</b> 
                {{ this.cotacao[0].data_pagamento ? this.cotacao[0].data_pagamento : "Sem data agendada"  }}
              </span>
            </div>
          </div>
          <div class="cc-footer">
            <div
              class="row m-0 p-10 linha-abaixo-cinza"
            >
              <div class="col-4">
                <span class="btn-function btn-voltar" @click="voltarCotacao()">
                  <i class="fas fa-arrow-left"></i> Voltar
                </span>
              </div>
              <div class="col-4">
                <span class="btn-function btn-aprovar" @click="aprovarCotacao()">Aprovar pedido</span>
              </div>
              <div class="col-4">
                <span class="btn-function btn-rejeitar" @click="$bvModal.show('modal-rejeitar')">Rejeitar pedido</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="comentarios" ref="comentarios" title="Comentarios" hide-footer>
      <template slot="modal-title">Dúvidas sobre esse produto</template>
      <div class="d-block text-center">
        <div class="limit_comentarios">
          <div
            class="comentarios_mensagens"
            v-for="(mensagem, index) in mensagensCotacao"
            :key="index"
          >
            <div
              class="row m-0"
              v-if="mensagem.usuario_enviador_id !== dadosUsuario.id"
            >
              <div class="tipo col-3 p-0">
                {{ mensagem.usuario_enviador.tipo_usuario.nome }}
              </div>
              <div class="mensagem col-9 p-0 text-left fs-14">
                {{ mensagem.mensagem }}
              </div>
            </div>
            <div class="row m-0" v-else>
              <div class="mensagem col-9 p-0 text-right fs-14">
                {{ mensagem.mensagem }}
              </div>
              <div class="tipo col-3 p-0">
                {{ mensagem.usuario_enviador.tipo_usuario.nome }}
              </div>
            </div>
          </div>
        </div>
        <div class="caixa_texto_mensagem">
          <div class="row m-0">
            <div class="col-9 p-j-right-10px">
              <textarea
                class="caixa_texto fs-12"
                placeholder="Digite sua dúvida e clique em anexar!"
                v-model="mensagem"
              ></textarea>
            </div>
            <div class="col-3 p-j-left-10px">
              <div
                class="btn btn-envio-mensagem"
                @click="
                  enviarMensagemProd(
                    dadosUsuario.id,
                    cotacao[0].id,
                    cotacao[0].cot_usuario_respondeu_id
                  )
                "
              >
                Anexar
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('comentarios')"
        >Fechar</b-button
      >
    </b-modal>
    <b-modal 
      id="modal-rejeitar"
      title="Rejeitar pedido"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <h5 class="mt-3">Informe o motivo pelo qual está rejeitando esse pedido?</h5>
      <input type="text" class="form-control" v-model="paylodRejeitar.motivo" placeholder="Digite o motivo aqui">
      <button class="btn btn-danger btn-block mt-2 mb-3" @click="sendRejeitarCotacao()">Rejeitar pedido</button>
    </b-modal>
    <b-modal 
      id="modal-aprovar"
      title="Aprovar pedido"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <span class="mt-3 mb-3 aprovarPedidoText">
        Ao aprovar esse pedido, sua loja estará se comprometendo a entregar os produtos, 
        bem como as devidas quantidades descritas no atual pedido dentro do período 
        informado no envio do orçamento. 
      </span>
      <span class="alertaTaxa">
        A não entrega ou o cancelamento poderá acarretar uma multa no valor de 
        {{ this.cotacao[0].taxa_cancelamento_sem_mascara > 99 ? this.cotacao[0].taxa_cancelamento : 'R$ 1,00'}}
      </span>
      <button class="btn btn-success btn-block mt-3 mb-3 m-2" @click="sendAprovarCotacao()">Aprovar pedido</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DownloadImages from '../../components/DownloadImages';
import ClientCotationInformation from '../../components/Client/ClientCotationInformation';
import ProfessionalCotationInformation from '../../components/Professional/ProfessionalCotationInformation';
import ShopkeeperCotationInformation from '../../components/Shopkeeper/ShopkeeperCotationInformation';
import RepresentativeCotationInformation from '../../components/Representative/RepresentativeCotationInformation';

export default {
  name: 'CotacaoAguardandoPagamento',
  components: {
    DownloadImages,
    ClientCotationInformation,
    ProfessionalCotationInformation,
    ShopkeeperCotationInformation,
    RepresentativeCotationInformation,
  },
  data: () => ({
    items: [],
    errors: [],
    mensagem: null,
    mensagemProdId: null,
    faturas: [],
    paylodRejeitar: {
      'idCotacao': null,
      'id': null,
      'motivo': ''
    }
  }),
  props: ['id'],
  created() {
    const self = this;

    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    setTimeout(() => {
      this.$store
        .dispatch('showCheckout', this.cotacao[0].cot_cotacao_id)
        .then((resp) => {
          const response = resp.data;
          this.faturas = response;
        });
    }, 5000);

    this.$store.dispatch('emptyCotacao').then(() => {
      this.$store.dispatch('startLoader');
      setTimeout(() => {
        self.$store
          .dispatch('showCotacaoRespondida', this.id)
          .then(() => {
            setTimeout(() => {
              self.$store.dispatch('endLoader');
            }, 1000);
          })
          .catch(() => {
            setTimeout(() => {
              self.$store
                .dispatch('showCotacaoRespondida', this.id)
                .then(() => {
                  setTimeout(() => {
                    self.$store.dispatch('endLoader');
                  }, 1000);
                })
                .catch(() => {
                  self.$store.dispatch('endLoader');
                  self.aviso(
                    'Não foi possível carregar as cotações! Tente novamente em 5 minutos!',
                    'danger'
                  );
                });
            }, 1000);
          });
      }, 1000);
    });
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      cotacao: (state) => state.cotacao,
      dadosUsuario: (state) => state.dadosUsuario,
      mensagensCotacao: (state) => state.mensagensCotacao,
      totalProdutos(state) {
        if (state.cotacao.length > 0) {
          let quantProdutos = 0;
          if (!this.checkIsEmpty(state.cotacao[0].produtos)) {
            if (state.cotacao[0].produtos.length > 0) {
              quantProdutos += state.cotacao[0].produtos.length;
            }
          }

          if (!this.checkIsEmpty(state.cotacao[0].produtosImagemArquivo)) {
            if (state.cotacao[0].produtosImagemArquivo.length > 0) {
              quantProdutos += state.cotacao[0].produtosImagemArquivo.length;
            }
          }

          return quantProdutos;
        }
      },
      quantProdutoRespondidos(state) {
        if (state.cotacao.length > 0) {
          let quantProdutos = 0;

          if (!this.checkIsEmpty(state.cotacao[0].produtos)) {
            if (state.cotacao[0].produtos.length > 0) {
              for (const produto in state.cotacao[0].produtos) {
                if (
                  (state.cotacao[0].produtos[produto].disponivel === 1 ||
                    state.cotacao[0].produtos[produto].disponivel === true) &&
                  (state.cotacao[0].produtos[produto].rejeitar === 0 ||
                    state.cotacao[0].produtos[produto].rejeitar === false)
                ) {
                  quantProdutos++;
                }
              }
            }
          }

          if (!this.checkIsEmpty(state.cotacao[0].produtosImagemArquivo)) {
            if (state.cotacao[0].produtosImagemArquivo.length > 0) {
              for (const produto in state.cotacao[0].produtosImagemArquivo) {
                if (
                  (state.cotacao[0].produtosImagemArquivo[produto]
                    .disponivel === 1 ||
                    state.cotacao[0].produtosImagemArquivo[produto]
                      .disponivel === true) &&
                  (state.cotacao[0].produtosImagemArquivo[produto].rejeitar ===
                    0 ||
                    state.cotacao[0].produtosImagemArquivo[produto].rejeitar ===
                      false)
                ) {
                  quantProdutos++;
                }
              }
            }
          }

          return quantProdutos;
        }
      },
    }),
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    sendRejeitarCotacao() {
      if(this.paylodRejeitar.motivo == '') {
        this.aviso('Informe o motivo para rejeitar o pedido!', 'danger');
        return
      }
      this.paylodRejeitar.idCotacao = this.cotacao[0].cot_cotacao_id
      this.paylodRejeitar.id = this.cotacao[0].id
      this.$store
        .dispatch('insertCotacaoRespostaRejeitadaLojista', this.paylodRejeitar)
        .then(() => {
          this.aviso('Pedido foi rejeitada com sucesso!', 'success');
          this.$bvModal.hide('modal-rejeitar');
          this.paylodRejeitar.idCotacao = null
          this.paylodRejeitar.id = null
          this.paylodRejeitar.motivo = ''
          setTimeout(() => {
            this.$router.push({
              name: 'lojista-rejeitadas-pelo-usuario',
            });
          }, 1000);
        });
    },
    sendAprovarCotacao() {
      const values = {
        id: this.cotacao[0].id,
        idCotacao: this.cotacao[0].cot_cotacao_id,
      };
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('aprovarCotacaoLojista', values)
        .then(() => {
          this.$bvModal.hide('modal-aprovar');
          setTimeout(() => {
            this.$store.dispatch('endLoader');
            this.aviso('Pedido foi aprovada com sucesso!', 'success');
            setTimeout(() => {
              this.$router.push({ name: 'lojista-ganhas' });
            }, 1000);
          }, 1500);
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.aviso(
            'Não foi possível aprovar a pedido! Tente novamente em 5 minutos!',
            'danger'
          );
        });
    },
    aprovarCotacao() {
      this.$bvModal.show('modal-aprovar');
    },
    voltarCotacao() {
      this.$router.push({
        name: 'aguardando-aprovacao',
      });
    },
    verMensagens(UsuarioEnviador, produtoId) {
      this.mensagemProdId = produtoId;
      this.$store
        .dispatch('showMensagensCotacaoResposta', produtoId)
        .then(() => {
          this.$bvModal.show('comentarios');
        });
    },
    enviarMensagemProd(UsuarioEnviador, cotacaoId, UsuarioRecebedor) {
      const self = this;
      const data = {
        usuario_enviador_id: UsuarioEnviador,
        cotacao_resposta_id: cotacaoId,
        cotacao_produto_id: this.mensagemProdId,
        usuario_recebedor_id: UsuarioRecebedor,
        mensagem: this.mensagem,
      };
      this.$store.dispatch('insertMensagem', data).then(() => {
        setTimeout(() => {
          if (this.getTipoNotification == 1) {
            this.aviso(this.getNotification, 'success');
          } else if (this.getTipoNotification == 3) {
            this.aviso(this.getNotification, 'danger');
          }
          this.$store.dispatch(
            'showMensagensCotacaoResposta',
            self.mensagemProdId
          );
          this.mensagem = null;
        }, 1000);
      });
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>

